import React from 'react';
import { useStateContext } from '../../context/ContextProvider';
import { media } from '../../server';
import Button from '../layout/Button';
import { IoArrowBackOutline } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';
import {Link} from "react-router-dom"
import { renderText, truncateText } from '../hooks/TextVeiw';
function ServiceCard({ service }) {
  const { currentDir } = useStateContext();
const { t } = useTranslation();
  // دالة لتقصير النص إلى 9 كلمات
 
  return (
    <div className='relative flex mt-12  rounded-tl-[50px] rounded-br-[50px] mx-auto gap-5 flex-col items-start p-10 bg-n-1 dark:bg-back-darktertiary shadow-lg border border-color-7 dark:border-color-10 dark:hover:border-color-7 hover:border-color-1'>
    <div className="top-[-40px] px-4 border border-color-1 dark:border-color-7 dark:bg-back-darksecondary  items-center justify-center py-2 w-30 h-15 min-h-15 bg-n-1 shadow-md absolute rounded-tl-[20px] rounded-br-[20px]   ">
      <img
        src={`${media}${service.icon}`}
        alt='service icon'
    
       className='w-10 color-n-1 h-10 object-contain'/>
    </div><div className=" flex flex-col gap-5 items-start "> <h2 className='h4 text-tcolor-4 dark:text-tcolor-1'>
        {currentDir === "ltr" ? service.titleEn : service.titleAr}
      </h2>
      <p className='body-1 text-tcolor-5 dark:text-tcolor-2'>
      {renderText(
          truncateText(
            currentDir === "ltr" ? service.textEn : service.textAr,
            8 // عدد الكلمات المطلوبة للقص
          )
        )}
      </p>
      <Link
          to={
           `/ServiceDetails`
          }state={{ServiceData:service}}
          onClick={() => {
          
            window.scrollTo(0, 0); 
        
          }}
        >
      <Button text={t('Read More')} Transform={true} nonBackground={true} textStyle={"font-kufi text-sm text-simeBold"}  textColor={"text-color-1"} icon={<IoArrowBackOutline />}/>
     </Link>
    </div></div>
  );
}

export default ServiceCard;